<template lang="pug">
.reserve-page
  .main-title
    .person
      .person-fullName
        .firstName Hello {{ $root.member.user_name }}
        .lastName {{ $root.member.name }}
      .person-avatar
        img.user-pic(:src="$root.member.user_picture", alt="alt")
    p 歡迎預約
  .sub-title 
    | 請選擇分店
  .station-list
    .station-item(
      v-for=" (station, index) in $root.stations" 
      @click="selectItem(station)" 
      :class="{active: currentStationId === station.id}"
      v-if="$root.hasProduct(station) && ($root.selectCity === '全部' || station.city === $root.selectCity)"
    )
      .on-select(v-if="currentStationId === station.id")
        img(src="../assets/images/check.svg")
      .station-pic
        .type-span {{ station.type }}
        .type-span.phone-register(v-if="station.onlyPhone") 電話預約
        img.station-banner-pic(:src="station.banner")
      .address-box
        .station-title
          | {{ station.name }}
          br(v-if="station.phone")
          span(v-if="station.phone") {{ station.phone }}
        .address 
          .location-icon
            img(src="../assets/images/time_icon.svg", alt="alt")
          .address-text
            span {{ station.time }}
        .address
          .location-icon
            img(src="../assets/images/location_icon.svg", alt="alt")
          .address-text
            | {{ station.address }}
        //- 車種
        .address.car-flex
          .row
            .car-item.col-xs-3(
              :key="carType.id"
              v-for="carType in $root.carTypes"
              v-if="carType.img && station.cars[carType.code] > 0"
              :data-code="carType.code"
              :data-carId="carType.id"
            )
              .car-icon(:class="'car_' + carType.id + '_image'")
                img(v-if="carType.img" :src="carType.img", alt="alt")
              .address-text
                span {{ station.cars[carType.code] }}

  .button-region.text-center(v-if="currentStationId")
    button.stepNext(type="button" @click="goNext()" :class="{active: currentStationId}") 
      .step-txt 下一步
</template>

<script>
export default {
  name: "reserve-page",
  components: {},
  data () {
    return {
      currentStationId: false,
    };
  },
  created () {
    this.currentStationId = false
    this.$root.register.stationId = false
  },
  mounted () {
    this.currentStationId = this.$root.register.stationId
  },
  methods: {
    selectItem (_station) {
      if (_station.onlyPhone) {
        return
      }

      this.currentStationId = _station.id
    },
    goNext () {
      if (this.currentStationId) {
        this.$root.register.stationId = this.currentStationId
        this.$root.goPage('/reserve-datetime')
      }
    }
  },
};
</script>
<style lang="sass" scoped>
.reserve-page
  // margin-top: 74px
  padding: 48px 35px 100px
  height: 100%
  overflow: auto
  .main-title
    .person
      display: flex
      justify-content: space-between
      align-items: center
      .person-fullName
        font-size: 32px
        font-weight: 700
        line-height: 2ex
        color: #fff
      .person-avatar
        width: 50px
        img
          width: 100%
          vertical-align: middle
    p
      font-size: 24px
      font-weight: 400
      color: #fff
      // padding-top: 13px
  .sub-title
    font-size: 18px
    font-weight: 700
    color: #898A8D
    padding-top: 34px
  .station-list
    color: #fff
    padding-top: 34px
    
    .station-item
      margin-bottom: 33px
      border-radius: 12px
      border: 3px solid #000
      position: relative
      &.active
        border: 3px solid #22F48FCC
      .on-select
        z-index: 9
        width: 60px
        height: 60px
        border-radius: 0 5px 0 10px
        background: #22F48FCC
        position: absolute
        right: 0
        top: 0
        display: flex
        align-items: center
      .station-pic
        width: 100%
        background-color: #535353
        border-radius: 10px 10px 0 0
        margin-inline: auto
        position: relative
        img.station-banner-pic
          border-radius: 10px 10px 0 0
        .type-span
          position: absolute
          left: 14px
          top: 13px
          padding: 1px 14px
          color: #000
          font-size: 3vmin
          background: #fff
          border-radius: 50px
        .phone-register
          left: 105px
          color: #FFF
          background: #F00
        img
          
      .address-box
        padding: 8px 13px 12px
        background: #1e1e1e
        border-radius: 0 0 10px 10px
        .station-title
          font-size: 24px
          font-weight: 700
          color: #fff
        .address
          display: flex
          align-items: center
          gap: 8px
          margin-top: 6px
          &.car-flex
            gap: 5px
          .row
            margin-left: 0px
          .car-item
            display: flex
            align-items: center
          .car-icon
            width: 9vmin
            margin-right: 1vmin
          .car_64_image
            img
              max-width: 9vmin
              max-height: 7vmin
          .location-icon
            width: 15px
            img
              width: 100%
          .address-text
            font-size: 3vmin
            
            span:first-child
              margin-right: 15px
.button-region
  text-align: center
  .stepNext
    padding-top: 15%
    width: 53.75vmin
    margin: auto
    border-radius: 12.5vmin
    background-color: #898A8D
    border: none
    padding: 3vmin 0px
    &.active
      background-color: #22F48F
    .step-txt
      text-align: center
      font-size: 6vmin
      font-weight: 700
      color: #1E1E1E
</style>
